import { render } from "./FloatingChat.vue?vue&type=template&id=0502b879&scoped=true"
import script from "./FloatingChat.vue?vue&type=script&lang=js"
export * from "./FloatingChat.vue?vue&type=script&lang=js"

import "../../dashboard/css/adminlte.css?vue&type=style&index=0&id=0502b879&lang=css&scoped=true&external"
import "./FloatingChat.vue?vue&type=style&index=1&id=0502b879&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0502b879"]])

export default __exports__